<script setup lang="ts">
  import { computed, useId } from 'vue'

  defineProps<{
    label: string,
  }>()

  const id = useId()
  const model = defineModel<string[]>({ required: true })

  const text = computed({
    get: () => model.value.join('\n'),
    set: (value: string) => {
      model.value = value.split('\n').map(s => s.trim())
    },
  })
</script>

<template>
  <div>
    <label
      v-if="label"
      :for="id"
      class="form-label mb-0!">
      {{ label }}
      <span class="text-danger-600">
        *
      </span>
    </label>
    <p class="text-xs text-gray-500 mb-2">
      1 item per baris
    </p>
    <app-input
      :id="id"
      v-model="text"
      v-focus
      :rows="5"
      type="textarea" />
  </div>
</template>

<style scoped>
  :deep() textarea {
    min-height: calc(var(--spacing) * 60);
  }
</style>
